import { requests } from "../helpers/api.services";
import { LOGIN_URL } from "../helpers/api.routes";
import ChangePassword from "../app/user/profile/components/ChangePassword";


export const AuthService = {
  getMe: () => requests.get(`${LOGIN_URL}/me`),
  login: (body: any) => requests.post(`${LOGIN_URL}/signin` , body),
  update: (params: any, id: number) =>
      requests.put(`${LOGIN_URL}`, params, true),
  changePassword: (params: any) =>
      requests.put(`${LOGIN_URL}/change-password`, params),
  // forgotPasswordRequest: (body: iForgotPassword) =>
  //   requests.post(`${RESET_PASSWORD_URL}/request`, body),
  // forgotPasswordChange: (body: any) =>
  //   requests.post(`${RESET_PASSWORD_URL}/change`, body),
};
